import { connect } from 'react-redux';
import StepsContainer from './TabStepsRenderer.container';
import { mapState, mapDispatch } from './TabStepsConnect';
import * as ITabSteps from './TabSteps.interfaces';

export default (connect(
  mapState,
  mapDispatch,
)(StepsContainer) as any) as React.FC<ITabSteps.ITabSteps>;
